(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-large.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-card/assets/javascripts/draw-card-variants/draw-card-large.js');
"use strict";


const ReactButton = svs.ui.ReactButton;
const _svs$components$tipse = svs.components.tipsen.drawCard,
  DrawCard = _svs$components$tipse.DrawCard,
  useConditionalWrapper = _svs$components$tipse.useConditionalWrapper;
const _svs$components$tipse2 = svs.components.tipsen.drawCard.constants,
  DRAW_CARD_ICON_SIZE = _svs$components$tipse2.DRAW_CARD_ICON_SIZE,
  DRAW_CARD_LAYOUTS = _svs$components$tipse2.DRAW_CARD_LAYOUTS,
  DRAW_CARD_TITLES = _svs$components$tipse2.DRAW_CARD_TITLES,
  DRAW_STATE = _svs$components$tipse2.DRAW_STATE,
  DRAW_STATE_TEXTS = _svs$components$tipse2.DRAW_STATE_TEXTS;
const _svs$components$tipse3 = svs.components.tipsen.drawCard.components,
  DrawCardPanel = _svs$components$tipse3.DrawCardPanel,
  DisabledOverlay = _svs$components$tipse3.DisabledOverlay;
const _svs$ui$ReactSpeechBu = svs.ui.ReactSpeechBubble,
  SpeechBubble = _svs$ui$ReactSpeechBu.SpeechBubble,
  SpeechBubbleSport3 = _svs$ui$ReactSpeechBu.SpeechBubbleSport3;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const DisabledOverlayWrapper = _ref => {
  let children = _ref.children;
  return React.createElement(DisabledOverlay, {
    isHorizontal: true
  }, children);
};
const DrawCardLarge = _ref2 => {
  var _renderDate$charAt;
  let betEvents = _ref2.betEvents,
    branding = _ref2.branding,
    className = _ref2.className,
    competitionDrawNumber = _ref2.competitionDrawNumber,
    extraMoney = _ref2.extraMoney,
    uniqueId = _ref2.uniqueId,
    _ref2$icon = _ref2.icon,
    icon = _ref2$icon === void 0 ? 'game-soccer' : _ref2$icon,
    _ref2$isListItem = _ref2.isListItem,
    isListItem = _ref2$isListItem === void 0 ? false : _ref2$isListItem,
    netSale = _ref2.netSale,
    onToggleDrawSelector = _ref2.onToggleDrawSelector,
    regCloseTime = _ref2.regCloseTime,
    _ref2$shouldShowChang = _ref2.shouldShowChangeDrawButton,
    shouldShowChangeDrawButton = _ref2$shouldShowChang === void 0 ? false : _ref2$shouldShowChang,
    state = _ref2.state,
    titleElement = _ref2.titleElement;
  const classNames = ['pg_draw_card_large'];
  className && classNames.push(className);
  const ConditionalDisabledOverlayWrapper = useConditionalWrapper(DisabledOverlayWrapper, {
    skip: state !== DRAW_STATE.TEMPORARY_CLOSED
  });
  const isCancelled = state === DRAW_STATE.CANCELLED;
  const isNotOpened = state === DRAW_STATE.NOT_OPENED;
  const isLive = state === DRAW_STATE.IS_LIVE;
  const isFinished = state === DRAW_STATE.FINISHED;
  const drawCardTitle = competitionDrawNumber > 0 ? "".concat(DRAW_CARD_TITLES.DRAW_DESCRIPTION, " ").concat(competitionDrawNumber) : DRAW_CARD_TITLES.DRAW_DESCRIPTION;
  const date = new Date(regCloseTime);
  const isValidDate = !isNaN(date);
  const renderDate = isValidDate ? formatDate(regCloseTime, true, true, false) : regCloseTime;
  const renderDataCapitalized = (renderDate === null || renderDate === void 0 || (_renderDate$charAt = renderDate.charAt(0)) === null || _renderDate$charAt === void 0 ? void 0 : _renderDate$charAt.toUpperCase()) + (renderDate === null || renderDate === void 0 ? void 0 : renderDate.slice(1));
  return React.createElement(ConditionalDisabledOverlayWrapper, null, React.createElement(DrawCard, {
    branding: branding,
    className: classNames.join(' '),
    layout: DRAW_CARD_LAYOUTS.HORIZONTAL
  }, React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(drawCardTitle, ": ").concat(titleElement),
    title: drawCardTitle
  }, (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoneyAndJackpot) && React.createElement(SpeechBubble, {
    size: "200"
  }, React.createElement(SpeechBubbleSport3, null, "".concat(extraMoney.amountForExtraMoneyWithJackpot, " kr i extrapengar"))), React.createElement(DrawCard.Title, {
    icon: icon,
    iconSize: DRAW_CARD_ICON_SIZE.LARGE
  }, titleElement)), isLive && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.STATE, ": live"),
    title: DRAW_CARD_TITLES.STATE
  }, React.createElement(DrawCard.Status, {
    isLive: true
  }, "Live")), isFinished && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.FINISHED),
    title: DRAW_CARD_TITLES.STATE
  }, React.createElement(DrawCard.Status, null, DRAW_STATE_TEXTS.FINISHED)), !isCancelled && !isLive && !isFinished && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.BET_STOP, ": ").concat(renderDataCapitalized),
    title: DRAW_CARD_TITLES.BET_STOP
  }, React.createElement(DrawCard.RegCloseTime, null, regCloseTime)), isNotOpened && !isLive && !isFinished && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.NOT_OPENED),
    title: DRAW_CARD_TITLES.STATE
  }, React.createElement(DrawCard.Status, null, DRAW_STATE_TEXTS.NOT_OPENED)), isCancelled && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.STATE, ": ").concat(DRAW_STATE_TEXTS.CANCELLED),
    title: DRAW_CARD_TITLES.STATE
  }, React.createElement(DrawCard.Status, {
    isCancelled: true
  }, DRAW_STATE_TEXTS.CANCELLED)), !isNotOpened && !isCancelled && netSale && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.NET_SALE, ": ").concat(currencyFromJupiterString(netSale), " kronor"),
    className: "draw_card_panel__net_sale",
    title: DRAW_CARD_TITLES.NET_SALE
  }, React.createElement(DrawCard.NetSale, {
    currencyCounterUniqueId: uniqueId
  }, netSale)), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isExtraMoney) && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.EXTRA_MONEY, ": ").concat(extraMoney.amount, " kronor"),
    className: "f-600",
    title: DRAW_CARD_TITLES.EXTRA_MONEY
  }, React.createElement(DrawCard.ExtraAmount, null, extraMoney.amount)), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isRolloverIn) && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.ROLL_OVER_IN, ": ").concat(extraMoney.amount, " kronor"),
    className: "f-600",
    title: DRAW_CARD_TITLES.ROLL_OVER_IN
  }, React.createElement(DrawCard.ExtraAmount, null, extraMoney.amount)), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isJackpot) && React.createElement(DrawCardPanel, {
    ariaLabel: "".concat(DRAW_CARD_TITLES.JACKPOT, ": ").concat(extraMoney.amount, " kronor"),
    className: "f-600",
    title: DRAW_CARD_TITLES.JACKPOT
  }, React.createElement(DrawCard.ExtraAmount, null, extraMoney.amount)), (extraMoney === null || extraMoney === void 0 ? void 0 : extraMoney.isGuaranteeJackpot) && React.createElement(DrawCardPanel, null, "En ensam vinnare \xE4r garanterad ".concat(extraMoney.amount, " kr")), !shouldShowChangeDrawButton && React.createElement(DrawCardPanel, {
    className: "draw_card_panel__bet_events",
    hasHiddenAria: !isListItem
  }, React.createElement(DrawCard.BetEvents, {
    limitToNumber: 1
  }, betEvents)), shouldShowChangeDrawButton && onToggleDrawSelector && React.createElement(DrawCardPanel, {
    className: "pg_draw_card_section--exclude-from-overlay"
  }, React.createElement(DrawCard.ChangeDraw, null, React.createElement(ReactButton, {
    block: true,
    inverted: true,
    onClick: onToggleDrawSelector,
    size: 300
  }, "Byt omg\xE5ng")))));
};
setGlobal('svs.components.tipsen.drawCard.DrawCardLarge', DrawCardLarge);

 })(window);